import { useEffect } from 'react'

export function useGlobalCtrlAndKeypress(onPress: (key: string) => boolean) {
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      // Ctrl+L / Cmd+L
      const isCtrlOrCmd = e.ctrlKey || e.metaKey
      if (!isCtrlOrCmd) return

      // if (e.key.toLowerCase() === 'l') {
      //   // Forsøg at blokere browserens address-bar shortcut
      //   e.preventDefault()
      //   e.stopPropagation()
      // }

      if (onPress(e.key.toLowerCase())) {
        e.preventDefault()
        e.stopPropagation()
      }
    }

    // capture=true for at komme tidligt i event flow
    window.addEventListener('keydown', onKeyDown, { capture: true })

    return () => {
      window.removeEventListener('keydown', onKeyDown, { capture: true } as any)
    }
  }, [onPress])
}

// DEBUG
// window.addEventListener(
//   "keydown",
//   (e) => {
//     if (e.key === "F2") {
//       console.log("activeElement:", document.activeElement);
//       console.log("outerHTML:", document.activeElement?.outerHTML);
//     }
//   },
//   true
// );